import { CurrencyPipe, DatePipe } from '@angular/common';
import { Component, input } from '@angular/core';
import { Organisation } from 'app/shared/models/organisation.model';

@Component({
  selector: 'ez-fee-info-box',
  imports: [CurrencyPipe, DatePipe],
  templateUrl: './fee-info-box.component.html',
  styleUrl: './fee-info-box.component.scss',
})
export class FeeInfoBoxComponent {
  readonly organisation = input.required<Organisation>();
  readonly amountInEuro = input<number>();
  readonly dueDate = input<Date>();
  readonly name = input<string>();
  readonly customerNumber = input<string>();
}
